"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DAY_MASK = exports.DAY_MASK = [/\d/, /\d/];
var YEAR_MASK = exports.YEAR_MASK = [/\d/, /\d/, /\d/, /\d/];